const Title = ({children}) =>{
  return (
    <div className={"text-lg/7 font-semibold tracking-[-0.015em] text-zinc-950 sm:text-base/7 dark:text-white"}>
      {children}
    </div>
  )
}

export default Title